import { apiRequest } from "../../../../shared/lib/api";
import type {
  ClubPayload,
  ClubRequestPayload,
  ClubRequestResponse,
  ClubResponse,
  ClubsResponse,
} from "../types/club";

function buildQuery(params: Record<string, string | number | null | undefined>) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    const normalized = String(value ?? "").trim();
    if (normalized) query.set(key, normalized);
  });
  const suffix = query.toString();
  return suffix ? `?${suffix}` : "";
}

export function listClubs(filters: {
  search?: string;
  city?: string;
  state?: string;
}) {
  return apiRequest<ClubsResponse>(
    `/api/clubs${buildQuery({
      search: filters.search,
      city: filters.city,
      state: filters.state,
    })}`,
  );
}

export function listNearbyClubs(filters: {
  search?: string;
  city?: string;
  state?: string;
  latitude?: number | null;
  longitude?: number | null;
  radiusKm?: number | null;
}) {
  return apiRequest<ClubsResponse>(
    `/api/clubs/nearby${buildQuery({
      search: filters.search,
      city: filters.city,
      state: filters.state,
      latitude: filters.latitude,
      longitude: filters.longitude,
      radiusKm: filters.radiusKm,
    })}`,
  );
}

export function getClubBySlug(slug: string) {
  return apiRequest<ClubResponse>(`/api/clubs/${encodeURIComponent(slug)}`);
}

export function requestClubRegistration(payload: ClubRequestPayload) {
  return apiRequest<ClubRequestResponse>("/api/clubs/requests", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function listAdminClubs(token: string, search = "") {
  return apiRequest<ClubsResponse>(
    `/api/admin/clubs${buildQuery({ search })}`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
}

export function createAdminClub(token: string, payload: ClubPayload) {
  return apiRequest<ClubResponse>("/api/admin/clubs", {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify(payload),
  });
}

export function updateAdminClub(
  token: string,
  clubId: number,
  payload: ClubPayload,
) {
  return apiRequest<ClubResponse>(`/api/admin/clubs/${clubId}`, {
    method: "PUT",
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify(payload),
  });
}

export function updateAdminClubStatus(
  token: string,
  clubId: number,
  isActive: boolean,
) {
  return apiRequest<ClubResponse>(`/api/admin/clubs/${clubId}/status`, {
    method: "PATCH",
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify({ isActive }),
  });
}

export function deleteAdminClub(token: string, clubId: number) {
  return apiRequest<{ ok: boolean }>(`/api/admin/clubs/${clubId}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });
}
